import { cloudChiprApi } from "../../../../services/cloudchipr.api";

export const resourceExplorerSingleResourceDataSelector =
  cloudChiprApi.endpoints
    .getUsersMeOrganisationsCurrentAccountsByAccountIdProvidersAndProviderResourceExplorerResources
    .select;
